/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandVue = createReactComponent("brand-vue", "IconBrandVue", [
  ["path", { d: "M16.5 4l-4.5 8l-4.5 -8", key: "svg-0" }],
  ["path", { d: "M3 4l9 16l9 -16", key: "svg-1" }]
]);

export { IconBrandVue as default };
//# sourceMappingURL=IconBrandVue.js.map
